/*# sourceMappingURL=translation-download-dialog.component-FCMMHZRU.css.map */
